module.exports = __webpack_public_path__ + "static/media/fmla-calculator.c21ce8d4.png";